export class AppNotification {
	constructor(
		public type: string,
		public payload?: any
	) { }
}
